import React, {useImperativeHandle, useRef} from 'react'
import Link from 'next/link'

import {ISidebar} from '@api/user/sidebar/getSidebar'
import {getLinkUrl, URL_ACCOUNT_SETTING} from '@constant/url'
import {useTranslation} from '@lib/intl/useTranslations'
import useQueryGetUserSidebar from '@hook/query/portfolio/useQueryGetUserSidebar'

import Text from '@component/Text/Text'
import WizButton from '@component/buttons/WizButton'
import WizContentModal from '@component/modal/WizContentModal'
import UserThumbnail from '@component/images/UserThumbnail'
import WizImage from '@component/images/WizImage'

import EditIcon from '@svg/common/ic_write.svg'
import ErrorIcon from '@svg/common/ic_noti_error.svg'

interface IProps {
    id?: string
    login_id?: string
}

const MobileUserProfileStatusModal = ({id, login_id}: IProps, ref: any) => {
    const t = useTranslation()
    const modalRef = useRef<any>()

    const {data: sidebar} = useQueryGetUserSidebar(id, false)

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
    }))

    return (
        <WizContentModal
            ref={modalRef}
            size={'600'}
            title={t('portfolio.user.memo.modal.title')}
            className={'px-[20px]'}
            panelClassName={'sm:flex-none sm:!rounded-[5px]'}>
            {sidebar?.status ? (
                <>
                    <div className={'flex items-center justify-between mt-[20px] mb-[10px]'}>
                        <UserProfileHeader sidebar={sidebar} />
                        {id === login_id && (
                            <Link href={getLinkUrl(URL_ACCOUNT_SETTING + '?edit=status')}>
                                <div className={'flex items-center gap-x-[7px] group'}>
                                    <EditIcon className={'w-[14px] fill-gray02 dark:fill-dark_gray02'} />
                                    <Text
                                        className={
                                            'text-body2 text-gray02 dark:text-dark_gray02 group-hover:underline'
                                        }>
                                        {t('portfolio.user.memo.edit.title')}
                                    </Text>
                                </div>
                            </Link>
                        )}
                    </div>

                    <Text className={'text-body2 text-gray02 dark:text-dark_gray02 max-h-[550px] overflow-y-scroll'}>
                        {sidebar?.status}
                    </Text>
                </>
            ) : (
                <div className={'space-y-[20px]'}>
                    <UserProfileHeader sidebar={sidebar} />
                    <div className={'flex flex-col items-center gap-y-[10px] mb-[10px]'}>
                        <ErrorIcon className={'w-[40px] fill-gray03 dark:fill-dark_gray03'} />
                        <Text className={'text-body1 text-gray02 dark:text-dark_gray02'}>
                            {t('portfolio.user.memo.empty.title')}
                        </Text>
                        {id === login_id && (
                            <Link href={getLinkUrl(URL_ACCOUNT_SETTING + '?edit=status')} className={'w-full'}>
                                <WizButton
                                    text={t('portfolio.user.memo.edit.title')}
                                    size={'small'}
                                    buttonType={'border'}
                                    className={'w-full'}
                                />
                            </Link>
                        )}
                    </div>
                </div>
            )}
        </WizContentModal>
    )
}

const UserProfileHeader = ({sidebar}: {sidebar: ISidebar}) => {
    return (
        <div className={'flex items-center'}>
            <UserThumbnail
                src={sidebar?.thumbnail}
                size={30}
                isPro={sidebar?.is_pro}
                containerClassName={'flex-none'}
            />
            <Text className={'text-ti2 text-gray01 dark:text-dark_gray01 ml-[5px]'}>{sidebar?.username}</Text>
            {sidebar?.flags?.length > 0 && (
                <WizImage
                    src={sidebar?.flags[0]}
                    width={16}
                    height={16}
                    containerClassName={'rounded-full overflow-hidden inline-block align-middle ml-[3px]'}
                />
            )}
        </div>
    )
}
export default React.forwardRef(MobileUserProfileStatusModal)
